import { render, staticRenderFns } from "./es.vue?vue&type=template&id=2ed8324a&scoped=true&lang=html&"
import script from "./es.vue?vue&type=script&lang=js&"
export * from "./es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8324a",
  null
  
)

export default component.exports